'use strict';

import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import 'angular-socket-io';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

import 'angular-validation-match';
import 'ng-file-upload';

import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import modal from '../components/modal/modal.service';
import sidebar from '../components/sidebar/sidebar.component';
// import footer from '../components/footer/footer.component';
import main from './main/main.component';
import sites from './sites/sites.component';
import site from './site/site.component';
import poste from './poste/poste.component';
import categories from './categories/categories.component';
import formation from './formation/formation.component';
import utilisateurs from './utilisateurs/utilisateurs.component';
import reporting from './reporting/reporting.component';
import borne from './borne';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';
import toastr from 'angular-toastr';
import datepicker from 'angularjs-datepicker';
import tooltips from 'angular-tooltips';
import moment from 'moment';
// import 'bootstrap-select';

// import './app.scss';
import '../assets/fonts/material-design-icons/css/material-design-iconic-font.css';
import '../assets/styles/main.css';
import '../assets/styles/custom.css';

import '../../node_modules/angular-toastr/dist/angular-toastr.css';
import '../../node_modules/angularjs-datepicker/dist/angular-datepicker.css';
import '../../node_modules/angular-tooltips/dist/angular-tooltips.css';
angular.module('aperamApp', [ngCookies, ngAnimate, ngResource, ngSanitize, 'btford.socket-io', 'ui.bootstrap-slider', uiRouter,
    uiBootstrap, _Auth, account, admin, 'validation.match', navbar, modal, sidebar, main, sites, site, poste, categories, formation,
    utilisateurs, reporting, borne, constants, socket, util, toastr, '720kb.datepicker', '720kb.tooltips', 'ngFileUpload'
  ])
  .config(routeConfig)
  .config(function(toastrConfig) {
    angular.extend(toastrConfig, {
      maxOpened: 1,
      target: 'body',
      closeDuration: 0
    });
  })
  .filter('roleFilter', function() {
    return function(input) {
      if (input == "admin") return 'Administrateur'
      if (input == "user") return 'Utilisateur'
    }
  })
  .filter('wellformed', function() {
    return function(input) {
      return input.charAt(0).toUpperCase() + input.slice(1).replace(/_/g, " ")
    }
  })
  .filter('wellformedTranslate', function(Traduction) {
    return function(input) {
      if(!Traduction.selectedLanguage || !Traduction.selectedLanguage.dictionnary.languagesList || !Traduction.selectedLanguage.dictionnary.languagesList[input]) return '';
      var newInput = Traduction.selectedLanguage.dictionnary.languagesList[input];
      return newInput.charAt(0).toUpperCase() + newInput.slice(1).replace(/_/g, " ");
    }
  })
  .filter('findNameIn', function() {
    return function(input, parent) {
      return _.find(parent, ['id', input]).flag.img
    }
  })
  .filter('translate', function(Traduction){
    function translate(input, test, test2){
      if(!Traduction.selectedLanguage) return '';
      return Traduction.selectedLanguage.dictionnary[input];
    }
    translate.$stateful = true;
    return translate;
  })
  .factory('Traduction', function($http){
    var Traduction = {};

    Traduction.changeLanguage = function(newLangue){
      if(Traduction.langues && !_.find(Traduction.langues, ['libelle', newLangue])) newLangue = Traduction.langues[0].libelle;
      $http.get('/api/miscs/lang?lang=' + newLangue).then(function(resp){
        Traduction.langues = resp.data.langues;
        Traduction.selectedLanguage = resp.data.langue;
        localStorage.setItem('lang', newLangue);
        location.reload();
      })
    }

    if(localStorage.getItem('lang') == null) localStorage.setItem('lang', 'fr');
    // Traduction.changeLanguage(localStorage.getItem('lang'));
    $http.get('/api/miscs/lang?lang=' + localStorage.getItem('lang')).then(function(resp){
        Traduction.langues = resp.data.langues;
        Traduction.selectedLanguage = resp.data.langue;
        localStorage.setItem('lang', localStorage.getItem('lang'));
      })
    return Traduction;
  })
  .run(function($rootScope, $location, Auth) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if (next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  })
  .directive('loadingDiv', function(Traduction) {
    if(!Traduction.selectedLanguage) return {};
    return {
      restrict: 'E',
      template: `<div class="loading-div"><img src="../assets/img/loading.gif"><h2>${Traduction.selectedLanguage.dictionnary["loading"]}</h2></div>`
    }
  })

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['aperamApp'], {
      // strictDi: true
    });
  });


angular.module('ui.bootstrap-slider', [])
  .directive('slider', ['$parse', '$timeout', '$rootScope', function($parse, $timeout, $rootScope) {
    return {
      restrict: 'AE',
      replace: true,
      template: '<div><input class="slider-input" type="text" style="width:100%" /></div>',
      require: 'ngModel',
      scope: {
        max: "=",
        min: "=",
        step: "=",
        value: "=",
        ngModel: '=',
        ngDisabled: '=',
        range: '=',
        sliderid: '=',
        ticks: '=',
        ticksLabels: '=',
        ticksSnapBounds: '=',
        ticksPositions: '=',
        ticksTooltip: "=",
        scale: '=',
        focus: '=',
        rangeHighlights: '=',
        formatter: '&',
        onStartSlide: '&',
        onStopSlide: '&',
        onSlide: '&'
      },
      link: function($scope, element, attrs, ngModelCtrl, $compile) {
        var ngModelDeregisterFn, ngDisabledDeregisterFn;

        var slider = initSlider();

        function initSlider() {
          var options = {};

          function setOption(key, value, defaultValue) {
            options[key] = value || defaultValue;
          }

          function setFloatOption(key, value, defaultValue) {
            options[key] = value || value === 0 ? parseFloat(value) : defaultValue;
          }

          function setBooleanOption(key, value, defaultValue) {
            options[key] = value ? value + '' === 'true' : defaultValue;
          }

          function getArrayOrValue(value) {
            return (angular.isString(value) && value.indexOf("[") === 0) ? angular.fromJson(value) : value;
          }

          setOption('id', $scope.sliderid);
          setOption('orientation', attrs.orientation, 'horizontal');
          setOption('selection', attrs.selection, 'before');
          setOption('handle', attrs.handle, 'round');
          setOption('tooltip', attrs.sliderTooltip || attrs.tooltip, 'show');
          setOption('tooltip_position', attrs.sliderTooltipPosition, 'top');
          setOption('tooltipseparator', attrs.tooltipseparator, ':');
          setOption('ticks', $scope.ticks);
          setOption('ticks_labels', $scope.ticksLabels);
          setOption('ticks_snap_bounds', $scope.ticksSnapBounds);
          setOption('ticks_positions', $scope.ticksPositions);
          setOption('ticks_tooltip', $scope.ticksTooltip, false);
          setOption('rangeHighlights', $scope.rangeHighlights);
          setOption('scale', $scope.scale, 'linear');
          setOption('focus', $scope.focus);

          setFloatOption('min', $scope.min, 0);
          setFloatOption('max', $scope.max, 10);
          setFloatOption('step', $scope.step, 1);
          var strNbr = options.step + '';
          var dotPos = strNbr.search(/[^.,]*$/);
          var decimals = strNbr.substring(dotPos);
          setFloatOption('precision', attrs.precision, decimals.length);

          setBooleanOption('tooltip_split', attrs.tooltipsplit, false);
          setBooleanOption('enabled', attrs.enabled, true);
          setBooleanOption('naturalarrowkeys', attrs.naturalarrowkeys, false);
          setBooleanOption('reversed', attrs.reversed, false);

          setBooleanOption('range', $scope.range, false);
          if (options.range) {
            if (angular.isArray($scope.value)) {
              options.value = $scope.value;
            } else if (angular.isString($scope.value)) {
              options.value = getArrayOrValue($scope.value);
              if (!angular.isArray(options.value)) {
                var value = parseFloat($scope.value);
                if (isNaN(value)) value = 5;

                if (value < $scope.min) {
                  value = $scope.min;
                  options.value = [value, options.max];
                } else if (value > $scope.max) {
                  value = $scope.max;
                  options.value = [options.min, value];
                } else {
                  options.value = [options.min, options.max];
                }
              }
            } else {
              options.value = [options.min, options.max]; // This is needed, because of value defined at $.fn.slider.defaults - default value 5 prevents creating range slider
            }
            $scope.ngModel = options.value; // needed, otherwise turns value into [null, ##]
          } else {
            setFloatOption('value', $scope.value, 5);
          }

          if (attrs.formatter) {
            options.formatter = function(value) {
              return $scope.formatter({ value: value });
            }
          }

          // check if slider jQuery plugin exists
          if (typeof window.$ !== 'undefined' && typeof $.fn === 'object' && $.fn.slider) {
            // adding methods to jQuery slider plugin prototype
            $.fn.slider.constructor.prototype.disable = function() {
              this.picker.off();
            };
            $.fn.slider.constructor.prototype.enable = function() {
              this.picker.on();
            };
          }

          // destroy previous slider to reset all options
          if (element[0].__slider)
            element[0].__slider.destroy();

          var slider = new Slider(element[0].getElementsByClassName('slider-input')[0], options);
          element[0].__slider = slider;

          // everything that needs slider element
          var updateEvent = getArrayOrValue(attrs.updateevent);
          if (angular.isString(updateEvent)) {
            // if only single event name in string
            updateEvent = [updateEvent];
          } else {
            // default to slide event
            updateEvent = ['slide'];
          }
          angular.forEach(updateEvent, function(sliderEvent) {
            slider.on(sliderEvent, function(ev) {
              ngModelCtrl.$setViewValue(ev);
            });
          });
          slider.on('change', function(ev) {
            ngModelCtrl.$setViewValue(ev.newValue);
          });


          // Event listeners
          var sliderEvents = {
            slideStart: 'onStartSlide',
            slide: 'onSlide',
            slideStop: 'onStopSlide'
          };
          angular.forEach(sliderEvents, function(sliderEventAttr, sliderEvent) {
            var fn = $parse(attrs[sliderEventAttr]);
            slider.on(sliderEvent, function(ev) {
              if ($scope[sliderEventAttr]) {
                $scope.$apply(function() {
                  fn($scope.$parent, { $event: ev, value: ev });
                });
              }
            });
          });

          // deregister ngDisabled watcher to prevent memory leaks
          if (angular.isFunction(ngDisabledDeregisterFn)) {
            ngDisabledDeregisterFn();
            ngDisabledDeregisterFn = null;
          }

          ngDisabledDeregisterFn = $scope.$watch('ngDisabled', function(value) {
            if (value) {
              slider.disable();
            } else {
              slider.enable();
            }
          });

          // deregister ngModel watcher to prevent memory leaks
          if (angular.isFunction(ngModelDeregisterFn)) ngModelDeregisterFn();
          ngModelDeregisterFn = $scope.$watch('ngModel', function(value) {
            if ($scope.range) {
              slider.setValue(value);
            } else {
              slider.setValue(parseFloat(value));
            }
            slider.relayout();
          }, true);

          return slider;
        }


        var watchers = ['min', 'max', 'step', 'range', 'scale', 'ticksLabels', 'ticks', 'rangeHighlights'];
        angular.forEach(watchers, function(prop) {
          $scope.$watch(prop, function() {
            slider = initSlider();
          });
        });

        var globalEvents = ['relayout', 'refresh', 'resize'];
        angular.forEach(globalEvents, function(event) {
          if (angular.isFunction(slider[event])) {
            $scope.$on('slider:' + event, function() {
              slider[event]();
            });
          }
        });
      }
    };
  }])



// WEBPACK FOOTER //
// ./client/app/app.js